import { CountryIconProps } from './types';

const CO = ({ dimension }: CountryIconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1046_3597)">
      <path
        d="M0 12C0 5.37263 5.37262 0 12 0C18.6274 0 24 5.37263 24 12L12 13.0435L0 12Z"
        fill="#FFDA44"
      />
      <path
        d="M1.60547 18.0005C3.68039 21.5872 7.55808 24.0005 11.9997 24.0005C16.4414 24.0005 20.319 21.5872 22.394 18.0005L11.9997 17.2179L1.60547 18.0005Z"
        fill="#D80027"
      />
      <path
        d="M22.3942 17.9998C23.4153 16.2347 24 14.1856 24 11.9998H0C0 14.1856 0.584719 16.2347 1.60575 17.9998H22.3942Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_1046_3597">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default CO;
